import f from "odata-filter-builder";

/**
 * Rebuild & return filter panel values to support syncfusion scheduler component
 * @param {*} e 
 * @param {*} valueChanged 
 * @returns 
 */
export function getCalendarFilterValues(e, valueChanged) {
    let filterValues = false;
    if (e.length > 0 && (valueChanged || valueChanged == undefined)) {
        var filter = undefined;
        e.forEach((element) => {
            if (Array.isArray(element)) {
                var filt = undefined;
                element.forEach((item) => {
                    if (Array.isArray(item)) {
                        if (!filt) {
                            if (item[1] == "=") {
                                filt = f().eq(item[0], item[2]);
                            } else if (item[1] == "contains") {
                                filt = f()
                                    .contains((x) => x.toLower(item[0]), item[2])
                                    .toString();
                            }
                        } else {
                            if (item[1] == "=") {
                                filt =
                                    f()
                                        .eq(item[0], item[2])
                                        .toString() +
                                    " or " +
                                    filt;
                            } else if (item[1] == "contains") {
                                filt =
                                    f()
                                        .contains((x) => x.toLower(item[0]), item[2])
                                        .toString() +
                                    " or " +
                                    filt;
                            }
                        }
                    }
                });
                if (!filter) {
                    filter = `(${filt})`;
                } else {
                    filter = filter + ` and (${filt})`;
                }
            }
        });

        if (filter == undefined) filterValues = false;
        else filterValues = filter;
    } else {
        if (e.length == 0 && valueChanged) filterValues = false;
    }

    return filterValues;
}